<template lang="pug">
  div(:class="b()")
    div(:class="b('bar')" :style="{ width: barWidth }")
</template>

<script>
  export default {
    name: 'rtc-progress-bar',

    props: {
      value: { type: Number, default: 0 },
    },

    computed: {
      barWidth() {
        return `${this.value}%`;
      },
    },
  };
</script>

<style lang="sass" scoped>
  .rtc-progress-bar
    position: relative
    height: 4px
    background-color: #f2f6fa

    &__bar
      height: 100%
      background-image: $trustColumnGradient
      border-radius: 0px 2px 2px 0px
      transition: width .8s
</style>